import { render } from "./StoryProposalAction.vue?vue&type=template&id=69f68400&scoped=true"
import script from "./StoryProposalAction.vue?vue&type=script&lang=js"
export * from "./StoryProposalAction.vue?vue&type=script&lang=js"

import "./StoryProposalAction.vue?vue&type=style&index=0&id=69f68400&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f68400"]])

export default __exports__